// import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import SpecialOffers from './SpecialOffers.component';
import PropTypes from 'prop-types';
import { CategoriesDispatcher } from "../../../store/Categories";


/** @namespace ScandiPWA/Blog/Component/SpecialOffers/Container/mapStateToProps */
// eslint-disable-next-line no-unused-vars
export const mapStateToProps = (state) => ({
    categoryFilter: state.CategoriesReducer.categoryFilter,
    categoryFilterOptionsArrays: state.CategoriesReducer.categoryFilterOptionsArrays
});

/** @namespace ScandiPWA/Blog/Component/SpecialOffers/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    requestCategoriesFilters: (options) => CategoriesDispatcher.handleData(dispatch,  options ),
});


/** @namespace ScandiPWA/Blog/Component/SpecialOffers/Container */
class SpecialOffersContainer extends PureComponent {
    static defaultProps = {
        categoryFilter : {
            items : []
        },
        categoryFilterOptionsArrays : {
            list_type : []
        }
    };

    static propTypes = {
        categoryFilter : PropTypes.object.isRequired,
        categoryFilterOptionsArrays : PropTypes.object.isRequired,
        requestCategoriesFilters : PropTypes.func.isRequired
    };

    componentDidMount() {
        const { requestCategoriesFilters, category_id } = this.props;
        requestCategoriesFilters({categoryId : category_id})
    }

    containerFunctions = {
        // getData: this.getData.bind(this)
    };

    containerProps = () => {
        // isDisabled: this._getIsDisabled()
    };

    render() {
        return (
            <SpecialOffers
              { ...this.containerFunctions }
              { ...this.containerProps() }
              { ...this.props }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialOffersContainer);
